"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fork = void 0;
const helper_1 = require("../../helper");
const sha256v1_1 = require("../sha256v1");
const types_1 = require("../types");
const constants_1 = require("../constants");
const transform_helper_1 = require("./transform-helper");
/**
 * Original-ish V1 transform behavior.
 * Going to create an ibGib containing the fork data.
 * Apply that fork and create a resulting ibGib.
 *
 * Takes the src ibGib, clears its past and adds a link to
 * the src via the 'ancestor' rel8n.
 *
 * NOTE:
 *   This is NOT going to do the plan^gib stuff ATM.
 *   Also this does NOT add any identity information ATM.
 */
function fork(opts) {
    return __awaiter(this, void 0, void 0, function* () {
        const { noTimestamp, dna, linkedRel8ns, destIb, uuid, tjp, cloneRel8ns, cloneData, type = 'fork', } = opts;
        let src = opts.src;
        const lc = '[fork_v1]';
        // #region validation
        if (type !== 'fork') {
            throw new Error(`${lc} not a fork transform.`);
        }
        if (!opts.type) {
            opts.type = 'fork';
        }
        if (!src) {
            throw new Error(`${lc} src required to fork.`);
        }
        if (!src.ib) {
            throw new Error(`${lc} src.ib required.`);
        }
        // destIb is not required, as it just reuses src.ib
        if (destIb && destIb.includes(constants_1.IBGIB_DELIMITER)) {
            throw new Error(`${lc} destIb can't contain (hardcoded) delimiter right now.`);
        }
        if (!src.gib) {
            throw new Error(`${lc} src.gib required.`);
        }
        // #endregion
        // we want to forget `src` proper very quickly because it may have other
        // non-IbGib properties that are not relevant to our transform.
        let dto = { ib: src.ib, gib: src.gib, };
        if (src.data && Object.keys(src.data).length > 0) {
            dto.data = src.data;
        }
        if (src.rel8ns && Object.keys(src.rel8ns).length > 0) {
            dto.rel8ns = src.rel8ns;
        }
        src = dto;
        const srcAddr = (0, helper_1.getIbGibAddr)({ ib: src.ib, gib: src.gib });
        opts.srcAddr = srcAddr;
        const rel8ns = cloneRel8ns && src.rel8ns && Object.keys(src.rel8ns).length > 0 ?
            (0, helper_1.clone)(src.rel8ns) :
            {};
        const data = cloneData && (src === null || src === void 0 ? void 0 : src.data) ? (0, helper_1.clone)(src.data) : {};
        if (opts.nCounter) {
            data.n = 0;
        }
        const ancestor = (linkedRel8ns === null || linkedRel8ns === void 0 ? void 0 : linkedRel8ns.includes(types_1.Rel8n.ancestor)) ?
            [srcAddr] :
            (rel8ns.ancestor || []).concat([srcAddr]);
        rel8ns.ancestor = ancestor;
        // remove tjp if exists in rel8ns
        if (rel8ns.tjp) {
            delete rel8ns.tjp;
        }
        const newIbGib = (0, helper_1.clone)(src);
        if (noTimestamp && (tjp === null || tjp === void 0 ? void 0 : tjp.timestamp)) {
            throw new Error(`${lc} both noTimestamp and tjp.timestamp selected.`);
        }
        if (!noTimestamp || (tjp === null || tjp === void 0 ? void 0 : tjp.timestamp)) {
            data.timestamp = (0, helper_1.getTimestamp)();
        }
        if ((tjp === null || tjp === void 0 ? void 0 : tjp.uuid) || uuid) {
            data.uuid = yield (0, helper_1.getUUID)();
        }
        if ((tjp === null || tjp === void 0 ? void 0 : tjp.uuid) || (tjp === null || tjp === void 0 ? void 0 : tjp.timestamp)) {
            data.isTjp = true;
        }
        else {
            if (data.isTjp) {
                delete data.isTjp;
            }
        }
        newIbGib.ib = destIb || 'ib';
        // rel8ns ignored if forking from the root ib^gib
        if (srcAddr !== constants_1.ROOT_ADDR) {
            newIbGib.rel8ns = rel8ns;
        }
        if (Object.keys(data).length > 0) {
            newIbGib.data = data;
        }
        let transformDna = null;
        if (dna) {
            transformDna = yield (0, transform_helper_1.buildDna)(opts);
            const dnaAddr = (0, helper_1.getIbGibAddr)({ ibGib: transformDna });
            rel8ns.dna = (linkedRel8ns === null || linkedRel8ns === void 0 ? void 0 : linkedRel8ns.includes(types_1.Rel8n.dna)) ?
                rel8ns.dna = [dnaAddr] :
                rel8ns.dna = (rel8ns.dna || []).concat(dnaAddr);
        }
        newIbGib.gib = yield (0, sha256v1_1.sha256v1)(newIbGib, '');
        const result = { newIbGib };
        if (transformDna) {
            result.dnas = [transformDna];
        }
        return result;
    });
}
exports.fork = fork;
